export const GRANULARITY = [{ label: 'Overall', value: 'overall' }, { label: 'Detailed', value: 'detailed' }];

export const ACTIVITY_STATS_LEVELS = [
  { label: 'Programme', value: 'programme' },
  { label: 'Service Provider', value: 'serviceProvider' },
  { label: 'Intervention', value: 'intervention' },
  { label: 'Institution', value: 'institution' },
  { label: 'Stakeholder', value: 'stakeholder' },
];

export const OVERALL_PROGRAMME_STATS = [
  { label: 'Programme ID', key: 'interventionProgrammeId' },
  { label: 'Programme', key: 'interventionProgrammeName' },
  { label: 'Activity Name', key: 'name' },
  { label: 'No. of Planned Sessions', key: 'numberOfSessions' },
  { label: 'No. of Actual Sessions', key: 'numberOfActualSessions' },
  { label: 'Attendance Rate', key: 'attendanceRate' },
];

export const OVERALL_SP_STATS = [
  { label: 'Service Provider ID', key: 'serviceProviderIds' },
  { label: 'Service Provider', key: 'serviceProviderNames' },
  { label: 'Programme', key: 'interventionProgrammeName' },
  { label: 'Activity Name', key: 'name' },
  { label: 'No. of Planned Sessions', key: 'numberOfSessions' },
  { label: 'No. of Actual Sessions', key: 'numberOfActualSessions' },
  { label: 'Planned Attendees per Session', key: 'plannedAttendees' },
  { label: 'Attendance Rate', key: 'attendanceRate' },
];

export const OVERALL_INTERVENTION_STATS = [
  { label: 'Intervention ID', key: 'interventionIds' },
  { label: 'Intervention', key: 'interventionNames' },
  { label: 'Activity Name', key: 'name' },
  { label: 'No. of Planned Sessions', key: 'numberOfSessions' },
  { label: 'No. of Actual Sessions', key: 'numberOfActualSessions' },
  { label: 'Planned Attendees per Session', key: 'plannedAttendees' },
  { label: 'Attendance Rate', key: 'attendanceRate' },
  { label: 'Service Provider', key: 'serviceProviderNames' },
  { label: 'Programme', key: 'interventionProgrammeName' },
  { label: 'School Subject', key: 'interventionSubjects' },
  { label: 'Other Subject', key: 'interventionFocusSubjects' },
  { label: 'Grade', key: 'interventionGrades' },
  { label: 'Start Date', key: 'interventionStartDate' },
  { label: 'End Date', key: 'interventionEndDate' },
];

export const OVERALL_INSTITUTION_STATS = [
  { label: 'EMIS Number', key: 'interventionInstitutionEmisNumber' },
  { label: 'Institution Name', key: 'interventionInstitutionName' },
  { label: 'Activity Name', key: 'name' },
  { label: 'No. of Planned Sessions', key: 'numberOfSessions' },
  { label: 'No. of Actual Sessions', key: 'numberOfActualSessions' },
  { label: 'Planned Attendees per Session', key: 'plannedAttendees' },
  { label: 'Attendance Rate', key: 'attendanceRate' },
  { label: 'Service Provider', key: 'serviceProviderNames' },
  { label: 'Programme', key: 'interventionProgrammeName' },
  { label: 'Intervention ID', key: 'interventionIds' },
  { label: 'Intervention', key: 'interventionNames' },
  { label: 'School Subject', key: 'interventionSubjects' },
  { label: 'Other Subject', key: 'interventionFocusSubjects' },
  { label: 'Grade', key: 'interventionGrades' },
  { label: 'Start Date', key: 'interventionStartDate' },
  { label: 'End Date', key: 'interventionEndDate' },
];

export const OVERALL_STAKEHOLDER_LEARNERS_STATS = [
  { label: 'EMIS Number', key: 'stakeholderEmisNumber' }, // Primary Institution
  { label: 'Institution Name', key: 'stakeholderInstitutionName' }, // Primary Institution
  { label: 'Stakeholder Type', key: 'stakeholderType' }, // Learner
  { label: 'Stakeholder ID', key: 'id' },
  { label: 'Tracking ID', key: 'stakeholderTrackingId' },
  { label: 'First Name', key: 'stakeholderFirstName' },
  { label: 'Last Name', key: 'stakeholderLastName' },
  { label: 'National ID', key: 'stakeholderNationalId' },
  { label: 'Date of Birth', key: 'stakeholderDOB' },
  { label: 'Contact Number', key: 'stakeholderContactNumber' },
  { label: 'Activity Name', key: 'name' },
  { label: 'No. of Planned Sessions', key: 'numberOfSessions' },
  { label: 'No. of Actual Sessions', key: 'numberOfActualSessions' },
  { label: 'No. of Sessions Attended', key: 'stakeholderSessionsAttended' },
  { label: 'Attendance Rate', key: 'attendanceRate' }, // = No. of Sessions Attended/No. of Actual Sessions
  { label: 'Programme', key: 'interventionProgrammeName' },
  { label: 'Service Provider', key: 'serviceProviderNames' },
  { label: 'Intervention ID', key: 'interventionIds' },
  { label: 'Intervention', key: 'interventionNames' },
  { label: 'School Subject', key: 'interventionSubjects' },
  { label: 'Other Subject', key: 'interventionFocusSubjects' },
  { label: 'Grade', key: 'interventionGrades' },
  { label: 'Start Date', key: 'interventionStartDate' }, // <Intervention>
  { label: 'End Date', key: 'interventionEndDate' }, // <Intervention>
];

export const OVERALL_STAKEHOLDER_SCHOOL_OFFICIALS_STATS = [
  { label: 'EMIS Number', key: 'stakeholderEmisNumber' }, // Primary Institution
  { label: 'Institution Name', key: 'stakeholderInstitutionName' }, // Primary Institution
  { label: 'Stakeholder Type', key: 'stakeholderType' }, // School Official
  { label: 'Stakeholder ID', key: 'id' },
  { label: 'Persal Number', key: 'stakeholderPersalNumber' },
  { label: 'First Name', key: 'stakeholderFirstName' },
  { label: 'Last Name', key: 'stakeholderLastName' },
  { label: 'National ID', key: 'stakeholderNationalId' },
  { label: 'Date of Birth', key: 'stakeholderDOB' },
  { label: 'Contact Number', key: 'stakeholderContactNumber' },
  { label: 'Activity Name', key: 'name' },
  { label: 'No. of Planned Sessions', key: 'numberOfSessions' },
  { label: 'No. of Actual Sessions', key: 'numberOfActualSessions' },
  { label: 'No. of Sessions Attended', key: 'stakeholderSessionsAttended' },
  { label: 'Attendance Rate', key: 'attendanceRate' }, // = No. of Sessions Attended/No. of Actual Sessions
  { label: 'Programme', key: 'interventionProgrammeName' },
  { label: 'Service Provider', key: 'serviceProviderNames' },
  { label: 'Intervention ID', key: 'interventionIds' },
  { label: 'Intervention', key: 'interventionNames' },
  { label: 'School Subject', key: 'interventionSubjects' },
  { label: 'Other Subject', key: 'interventionFocusSubjects' },
  { label: 'Grade', key: 'interventionGrades' },
  { label: 'Start Date', key: 'interventionStartDate' }, // <Intervention>
  { label: 'End Date', key: 'interventionEndDate' }, // <Intervention>
];

export const OVERALL_STAKEHOLDER_DISTRICT_OFFICIALS_STATS = [
  { label: 'EMIS Number', key: 'stakeholderEmisNumber' }, // Primary Institution
  { label: 'Institution Name', key: 'stakeholderInstitutionName' }, // Primary Institution
  { label: 'Stakeholder Type', key: 'stakeholderType' }, // District Officials
  { label: 'Stakeholder ID', key: 'id' },
  { label: 'Persal Number', key: 'stakeholderPersalNumber' },
  { label: 'First Name', key: 'stakeholderFirstName' },
  { label: 'Last Name', key: 'stakeholderLastName' },
  { label: 'National ID', key: 'stakeholderNationalId' },
  { label: 'Date of Birth', key: 'stakeholderDOB' },
  { label: 'Contact Number', key: 'stakeholderContactNumber' },
  { label: 'Activity Name', key: 'name' },
  { label: 'No. of Planned Sessions', key: 'numberOfSessions' },
  { label: 'No. of Actual Sessions', key: 'numberOfActualSessions' },
  { label: 'No. of Sessions Attended', key: 'stakeholderSessionsAttended' },
  { label: 'Attendance Rate', key: 'attendanceRate' }, // = No. of Sessions Attended/No. of Actual Sessions
  { label: 'Programme', key: 'interventionProgrammeName' },
  { label: 'Service Provider', key: 'serviceProviderNames' },
  { label: 'Intervention ID', key: 'interventionIds' },
  { label: 'Intervention', key: 'interventionNames' },
  { label: 'School Subject', key: 'interventionSubjects' },
  { label: 'Other Subject', key: 'interventionFocusSubjects' },
  { label: 'Grade', key: 'interventionGrades' },
  { label: 'Start Date', key: 'interventionStartDate' }, // <Intervention>
  { label: 'End Date', key: 'interventionEndDate' }, // <Intervention>
];

export const OVERALL_STAKEHOLDER_PROVINCIAL_OFFICIALS_STATS = [
  { label: 'Country', key: 'stakeholderCountryName' },
  { label: 'Province', key: 'stakeholderProvinceName' },
  { label: 'Branch', key: 'stakeholderBranchName' },
  { label: 'Stakeholder Type', key: 'stakeholderType' }, // Provincial Official
  { label: 'Stakeholder ID', key: 'id' },
  { label: 'Persal Number', key: 'stakeholderPersalNumber' },
  { label: 'First Name', key: 'stakeholderFirstName' },
  { label: 'Last Name', key: 'stakeholderLastName' },
  { label: 'National ID', key: 'stakeholderNationalId' },
  { label: 'Date of Birth', key: 'stakeholderDOB' },
  { label: 'Contact Number', key: 'stakeholderContactNumber' },
  { label: 'Activity Name', key: 'name' },
  { label: 'No. of Planned Sessions', key: 'numberOfSessions' },
  { label: 'No. of Actual Sessions', key: 'numberOfActualSessions' },
  { label: 'No. of Sessions Attended', key: 'stakeholderSessionsAttended' },
  { label: 'Attendance Rate', key: 'attendanceRate' }, // = No. of Sessions Attended/No. of Actual Sessions
  { label: 'Programme', key: 'interventionProgrammeName' },
  { label: 'Service Provider', key: 'serviceProviderNames' },
  { label: 'Intervention ID', key: 'interventionIds' },
  { label: 'Intervention', key: 'interventionNames' },
  { label: 'School Subject', key: 'interventionSubjects' },
  { label: 'Other Subject', key: 'interventionFocusSubjects' },
  { label: 'Grade', key: 'interventionGrades' },
  { label: 'Start Date', key: 'interventionStartDate' }, // <Intervention>
  { label: 'End Date', key: 'interventionEndDate' }, // <Intervention>
];

export const OVERALL_STAKEHOLDER_COMMUNITY_MEMBER_STATS = [
  { label: 'Community Type', key: 'stakeholderCommunityType' },
  { label: 'Stakeholder Type', key: 'stakeholderType' }, // Community Member
  { label: 'Stakeholder ID', key: 'id' },
  { label: 'First Name', key: 'stakeholderFirstName' },
  { label: 'Last Name', key: 'stakeholderLastName' },
  { label: 'National ID', key: 'stakeholderNationalId' },
  { label: 'Gender', key: 'stakeholderGender' },
  { label: 'Date of Birth', key: 'stakeholderDOB' },
  { label: 'Contact Number', key: 'stakeholderContactNumber' },
  { label: 'Activity Name', key: 'name' },
  { label: 'No. of Planned Sessions', key: 'numberOfSessions' },
  { label: 'No. of Actual Sessions', key: 'numberOfActualSessions' },
  { label: 'No. of Sessions Attended', key: 'stakeholderSessionsAttended' },
  { label: 'Attendance Rate', key: 'attendanceRate' }, // = No. of Sessions Attended/No. of Actual Sessions
  { label: 'Programme', key: 'interventionProgrammeName' },
  { label: 'Service Provider', key: 'serviceProviderNames' },
  { label: 'Intervention ID', key: 'interventionIds' },
  { label: 'Intervention', key: 'interventionNames' },
  { label: 'School Subject', key: 'interventionSubjects' },
  { label: 'Other Subject', key: 'interventionFocusSubjects' },
  { label: 'Grade', key: 'interventionGrades' },
  { label: 'Start Date', key: 'interventionStartDate' }, // <Intervention>
  { label: 'End Date', key: 'interventionEndDate' }, // <Intervention>
];

export const DETAILED_PROGRAMME_STATS = [
  { label: 'Programme ID', key: 'programmeIds' },
  { label: 'Programme', key: 'programmeNames' },
  { label: 'Activity Name', key: 'name' },
  { label: 'Session Name', key: 'sessionName' },
  { label: 'Description', key: 'sessionDescription' },
  { label: 'Institution', key: 'sessionInstitutions' },
  { label: 'Group', key: '' }, // Should pull Tags which are in scope for activity feature enhancement
  { label: 'Planned Date', key: 'sessionPlannedDate' },
  { label: 'Actual Date', key: 'sessionActualDate' },
  { label: 'Planned Duration (min)', key: 'plannedDuration' },
  { label: 'Actual Duration (min)', key: 'sessionActualDuration' },
  { label: 'Planned Attendees', key: 'plannedAttendees' },
  { label: 'Actual Attendees', key: 'sessionActualAttendees' },
  { label: 'Attendance Rate', key: 'sessionAttendanceRate' },
  { label: 'Status', key: 'sessionStatus' },
  { label: 'Notes', key: 'sessionNotes' },
];

export const DETAILED_SP_STATS = [
  { label: 'Service Provider ID', key: 'serviceProviderIds' },
  { label: 'Service Provider', key: 'serviceProviderNames' },
  { label: 'Programme', key: 'programmeNames' },
  { label: 'Activity Name', key: 'name' },
  { label: 'Session Name', key: 'sessionName' },
  { label: 'Description', key: 'sessionDescription' },
  { label: 'Institution', key: 'sessionInstitutions' },
  { label: 'Group', key: '' }, // Should pull Tags which are in scope for activity feature enhancement
  { label: 'Planned Date', key: 'sessionPlannedDate' },
  { label: 'Actual Date', key: 'sessionActualDate' },
  { label: 'Planned Duration (min)', key: 'plannedDuration' },
  { label: 'Actual Duration (min)', key: 'sessionActualDuration' },
  { label: 'Planned Attendees', key: 'plannedAttendees' },
  { label: 'Actual Attendees', key: 'sessionActualAttendees' },
  { label: 'Attendance Rate', key: 'sessionAttendanceRate' },
  { label: 'Status', key: 'sessionStatus' },
  { label: 'Notes', key: 'sessionNotes' },
];

export const DETAILED_INTERVENTION_STATS = [
  { label: 'Intervention ID', key: 'interventionIds' },
  { label: 'Intervention', key: 'interventionNames' },
  { label: 'Activity Name', key: 'name' },
  { label: 'Session Name', key: 'sessionName' },
  { label: 'Description', key: 'sessionDescription' },
  { label: 'Institution', key: 'sessionInstitutions' },
  { label: 'Group', key: '' }, // Should pull Tags which are in scope for activity feature enhancement
  { label: 'Planned Date', key: 'sessionPlannedDate' },
  { label: 'Actual Date', key: 'sessionActualDate' },
  { label: 'Planned Duration (min)', key: 'plannedDuration' },
  { label: 'Actual Duration (min)', key: 'sessionActualDuration' },
  { label: 'Planned Attendees', key: 'plannedAttendees' },
  { label: 'Actual Attendees', key: 'sessionActualAttendees' },
  { label: 'Attendance Rate', key: 'sessionAttendanceRate' },
  { label: 'Status', key: 'sessionStatus' },
  { label: 'Notes', key: 'sessionNotes' },
  { label: 'Service Provider', key: 'serviceProviderNames' },
  { label: 'Programme', key: 'programmeNames' },
  { label: 'School Subject', key: 'interventionSubjects' },
  { label: 'Other Subject', key: 'interventionFocusSubjects' },
  { label: 'Grade', key: 'interventionGrades' },
  { label: 'Start Date', key: 'interventionStartDate' }, // <Intervention>
  { label: 'End Date', key: 'interventionEndDate' }, // <Intervention>
];

export const DETAILED_INSTITUTION_STATS = [
  { label: 'EMIS Number', key: 'interventionInstitutionEmisNumber' },
  { label: 'Institution Name', key: 'interventionInstitutionName' },
  { label: 'Activity Name', key: 'name' },
  { label: 'Session Name', key: 'sessionName' },
  { label: 'Description', key: 'sessionDescription' },
  { label: 'Group', key: '' }, // Should pull Tags which are in scope for activity feature enhancement
  { label: 'Planned Date', key: 'sessionPlannedDate' },
  { label: 'Actual Date', key: 'sessionActualDate' },
  { label: 'Planned Duration (min)', key: 'plannedDuration' },
  { label: 'Actual Duration (min)', key: 'sessionActualDuration' },
  { label: 'Planned Attendees', key: 'plannedAttendees' },
  { label: 'Actual Attendees', key: 'sessionActualAttendees' },
  { label: 'Attendance Rate', key: 'sessionAttendanceRate' },
  { label: 'Status', key: 'sessionStatus' },
  { label: 'Notes', key: 'sessionNotes' },
  { label: 'Service Provider', key: 'serviceProviderNames' },
  { label: 'Programme', key: 'programmeNames' },
  { label: 'Intervention ID', key: 'interventionIds' },
  { label: 'Intervention', key: 'interventionNames' },
  { label: 'School Subject', key: 'interventionSubjects' },
  { label: 'Other Subject', key: 'interventionFocusSubjects' },
  { label: 'Grade', key: 'interventionGrades' },
  { label: 'Start Date', key: 'interventionStartDate' }, // <Intervention>
  { label: 'End Date', key: 'interventionEndDate' }, // <Intervention>
];

export const DETAILED_STAKEHOLDER_LEARNERS_STATS = [
  { label: 'EMIS Number', key: 'stakeholderEmisNumber' }, // [Primary Institution EMIS Number]
  { label: 'Institution Name', key: 'stakeholderInstitutionName' }, // [Primary Institution]
  { label: 'Stakeholder Type', key: 'stakeholderType' }, // Learner
  { label: 'Stakeholder ID', key: 'id' },
  { label: 'Tracking ID', key: 'stakeholderTrackingId' },
  { label: 'First Name', key: 'stakeholderFirstName' },
  { label: 'Last Name', key: 'stakeholderLastName' },
  { label: 'National ID', key: 'stakeholderNationalId' },
  { label: 'Date of Birth', key: 'stakeholderDOB' },
  { label: 'Contact Number', key: 'stakeholderContactNumber' },
  { label: 'Activity Name', key: 'name' },
  { label: 'Session Name', key: 'sessionName' }, // <Attended Session Name>
  { label: 'Description', key: 'sessionDescription' },
  { label: 'Actual Date', key: 'sessionActualDate' },
  { label: 'Actual Duration (min)', key: 'sessionActualDuration' },
  { label: 'Status', key: 'sessionStatus' },
  { label: 'Programme', key: 'programmeNames' },
  { label: 'Service Provider', key: 'serviceProviderNames' },
  { label: 'Intervention ID', key: 'interventionIds' },
  { label: 'Intervention', key: 'interventionNames' },
  { label: 'School Subject', key: 'interventionSubjects' },
  { label: 'Other Subject', key: 'interventionFocusSubjects' },
  { label: 'Grade', key: 'interventionGrades' },
  { label: 'Start Date', key: 'interventionStartDate' }, // <Intervention>
  { label: 'End Date', key: 'interventionEndDate' }, // <Intervention>
];

export const DETAILED_STAKEHOLDER_SCHOOL_OFFICIALS_STATS = [
  { label: 'EMIS Number', key: 'stakeholderEmisNumber' }, // [Primary Institution EMIS Number]
  { label: 'Institution Name', key: 'stakeholderInstitutionName' }, // [Primary Institution]
  { label: 'Stakeholder Type', key: 'stakeholderType' }, // School Official
  { label: 'Stakeholder ID', key: 'id' },
  { label: 'Persal Number', key: 'stakeholderPersalNumber' },
  { label: 'First Name', key: 'stakeholderFirstName' },
  { label: 'Last Name', key: 'stakeholderLastName' },
  { label: 'National ID', key: 'stakeholderNationalId' },
  { label: 'Date of Birth', key: 'stakeholderDOB' },
  { label: 'Contact Number', key: 'stakeholderContactNumber' },
  { label: 'Activity Name', key: 'name' },
  { label: 'Session Name', key: 'sessionName' }, // <Attended Session Name>
  { label: 'Description', key: 'sessionDescription' },
  { label: 'Actual Date', key: 'sessionActualDate' },
  { label: 'Actual Duration (min)', key: 'sessionActualDuration' },
  { label: 'Status', key: 'sessionStatus' },
  { label: 'Programme', key: 'programmeNames' },
  { label: 'Service Provider', key: 'serviceProviderNames' },
  { label: 'Intervention ID', key: 'interventionIds' },
  { label: 'Intervention', key: 'interventionNames' },
  { label: 'School Subject', key: 'interventionSubjects' },
  { label: 'Other Subject', key: 'interventionFocusSubjects' },
  { label: 'Grade', key: 'interventionGrades' },
  { label: 'Start Date', key: 'interventionStartDate' }, // <Intervention>
  { label: 'End Date', key: 'interventionEndDate' }, // <Intervention>
];

export const DETAILED_STAKEHOLDER_DISTRICT_OFFICIALS_STATS = [
  { label: 'EMIS Number', key: 'stakeholderEmisNumber' }, // [Primary Institution EMIS Number]
  { label: 'Institution Name', key: 'stakeholderInstitutionName' }, // [Primary Institution]
  { label: 'Stakeholder Type', key: 'stakeholderType' }, // District Officials
  { label: 'Stakeholder ID', key: 'id' },
  { label: 'Persal Number', key: 'stakeholderPersalNumber' },
  { label: 'First Name', key: 'stakeholderFirstName' },
  { label: 'Last Name', key: 'stakeholderLastName' },
  { label: 'National ID', key: 'stakeholderNationalId' },
  { label: 'Date of Birth', key: 'stakeholderDOB' },
  { label: 'Contact Number', key: 'stakeholderContactNumber' },
  { label: 'Activity Name', key: 'name' },
  { label: 'Session Name', key: 'sessionName' }, // <Attended Session Name>
  { label: 'Description', key: 'sessionDescription' },
  { label: 'Actual Date', key: 'sessionActualDate' },
  { label: 'Actual Duration (min)', key: 'sessionActualDuration' },
  { label: 'Status', key: 'sessionStatus' },
  { label: 'Programme', key: 'programmeNames' },
  { label: 'Service Provider', key: 'serviceProviderNames' },
  { label: 'Intervention ID', key: 'interventionIds' },
  { label: 'Intervention', key: 'interventionNames' },
  { label: 'School Subject', key: 'interventionSubjects' },
  { label: 'Other Subject', key: 'interventionFocusSubjects' },
  { label: 'Grade', key: 'interventionGrades' },
  { label: 'Start Date', key: 'interventionStartDate' }, // <Intervention>
  { label: 'End Date', key: 'interventionEndDate' }, // <Intervention>
];

export const DETAILED_STAKEHOLDER_PROVINCIAL_OFFICIALS_STATS = [
  { label: 'Country', key: 'stakeholderCountryName' },
  { label: 'Province', key: 'stakeholderProvinceName' },
  { label: 'Branch', key: 'stakeholderBranchName' },
  { label: 'Stakeholder Type', key: 'stakeholderType' }, // Provincial Official
  { label: 'Stakeholder ID', key: 'id' },
  { label: 'Persal Number', key: 'stakeholderPersalNumber' },
  { label: 'First Name', key: 'stakeholderFirstName' },
  { label: 'Last Name', key: 'stakeholderLastName' },
  { label: 'National ID', key: 'stakeholderNationalId' },
  { label: 'Date of Birth', key: 'stakeholderDOB' },
  { label: 'Contact Number', key: 'stakeholderContactNumber' },
  { label: 'Activity Name', key: 'name' },
  { label: 'Session Name', key: 'sessionName' }, // <Attended Session Name>
  { label: 'Description', key: 'sessionDescription' },
  { label: 'Actual Date', key: 'sessionActualDate' },
  { label: 'Actual Duration (min)', key: 'sessionActualDuration' },
  { label: 'Status', key: 'sessionStatus' },
  { label: 'Programme', key: 'programmeNames' },
  { label: 'Service Provider', key: 'serviceProviderNames' },
  { label: 'Intervention ID', key: 'interventionIds' },
  { label: 'Intervention', key: 'interventionNames' },
  { label: 'School Subject', key: 'interventionSubjects' },
  { label: 'Other Subject', key: 'interventionFocusSubjects' },
  { label: 'Grade', key: 'interventionGrades' },
  { label: 'Start Date', key: 'interventionStartDate' }, // <Intervention>
  { label: 'End Date', key: 'interventionEndDate' }, // <Intervention>
];

export const DETAILED_STAKEHOLDER_COMMUNITY_MEMBER_STATS = [
  { label: 'Community Type', key: 'stakeholderCommunityType' },
  { label: 'Stakeholder Type', key: 'stakeholderType' }, // Community Member
  { label: 'Stakeholder ID', key: 'id' },
  { label: 'First Name', key: 'stakeholderFirstName' },
  { label: 'Last Name', key: 'stakeholderLastName' },
  { label: 'National ID', key: 'stakeholderNationalId' },
  { label: 'Gender', key: 'stakeholderGender' },
  { label: 'Date of Birth', key: 'stakeholderDOB' },
  { label: 'Contact Number', key: 'stakeholderContactNumber' },
  { label: 'Activity Name', key: 'name' },
  { label: 'Session Name', key: 'sessionName' }, // <Attended Session Name>
  { label: 'Description', key: 'sessionDescription' },
  { label: 'Actual Date', key: 'sessionActualDate' },
  { label: 'Actual Duration (min)', key: 'sessionActualDuration' },
  { label: 'Status', key: 'sessionStatus' },
  { label: 'Programme', key: 'programmeNames' },
  { label: 'Service Provider', key: 'serviceProviderNames' },
  { label: 'Intervention ID', key: 'interventionIds' },
  { label: 'Intervention', key: 'interventionNames' },
  { label: 'School Subject', key: 'interventionSubjects' },
  { label: 'Other Subject', key: 'interventionFocusSubjects' },
  { label: 'Grade', key: 'interventionGrades' },
  { label: 'Start Date', key: 'interventionStartDate' }, // <Intervention>
  { label: 'End Date', key: 'interventionEndDate' }, // <Intervention>
];

export const activityStatsVisibleOptions = {
  programme: ['programme'],
  serviceProvider: ['programme', 'serviceProvider'],
  intervention: ['programme', 'serviceProvider', 'intervention'],
  institution: ['programme', 'serviceProvider', 'intervention', 'institution'],
  stakeholder: ['programme', 'serviceProvider', 'intervention', 'institution', 'stakeholder'],
};

export const activityStatsSelectOptions = {
  overall: {
    programme: OVERALL_PROGRAMME_STATS,
    serviceProvider: OVERALL_SP_STATS,
    intervention: OVERALL_INTERVENTION_STATS,
    institution: OVERALL_INSTITUTION_STATS,
    stakeholder: {
      'Community Member': OVERALL_STAKEHOLDER_COMMUNITY_MEMBER_STATS,
      'District Officials': OVERALL_STAKEHOLDER_DISTRICT_OFFICIALS_STATS,
      Learners: OVERALL_STAKEHOLDER_LEARNERS_STATS,
      'Provincial Officials': OVERALL_STAKEHOLDER_PROVINCIAL_OFFICIALS_STATS,
      'School Officials': OVERALL_STAKEHOLDER_SCHOOL_OFFICIALS_STATS,
    },
  },
  detailed: {
    programme: DETAILED_PROGRAMME_STATS,
    serviceProvider: DETAILED_SP_STATS,
    intervention: DETAILED_INTERVENTION_STATS,
    institution: DETAILED_INSTITUTION_STATS,
    stakeholder: {
      'Community Member': DETAILED_STAKEHOLDER_COMMUNITY_MEMBER_STATS,
      'District Officials': DETAILED_STAKEHOLDER_DISTRICT_OFFICIALS_STATS,
      Learners: DETAILED_STAKEHOLDER_LEARNERS_STATS,
      'Provincial Officials': DETAILED_STAKEHOLDER_PROVINCIAL_OFFICIALS_STATS,
      'School Officials': DETAILED_STAKEHOLDER_SCHOOL_OFFICIALS_STATS,
    },
  },
};
